// import api from './api';

// export const savingsService = {
//   async getMemberSavings(memberId) {
//     const response = await api.get(`/savings/member/${memberId}`);
//     return response.data;
//   },

//   async createAccount(accountData) {
//     const response = await api.post('/savings/account', accountData);
//     return response.data;
//   },

//   async deposit(accountId, depositData) {
//     const response = await api.post(`/savings/${accountId}/deposit`, depositData);
//     return response.data;
//   },

//   async withdraw(accountId, withdrawData) {
//     const response = await api.post(`/savings/${accountId}/withdraw`, withdrawData);
//     return response.data;
//   },

//   async getStatement(accountId, fromDate, toDate) {
//     const response = await api.get(`/savings/${accountId}/statement`, {
//       params: { from_date: fromDate, to_date: toDate }
//     });
//     return response.data;
//   },
// };
import api from "./api";

export const savingsService = {
  async getDepositSchemes() {
    const response = await api.get("/savings/schemes");
    return response.data;
  },

  async createAccount(accountData) {
    const response = await api.post("/savings/account", accountData);
    return response.data;
  },

  async getMemberSavings(memberId) {
    const response = await api.get(`/savings/member/${memberId}`);
    return response.data;
  },

  async getAccountDetails(accountId) {
    const response = await api.get(`/savings/accounts/${accountId}`);
    return response.data;
  },

  async deposit(accountId, depositData) {
    const response = await api.post(
      `/savings/${accountId}/deposit`,
      depositData,
    );
    return response.data;
  },

  async withdraw(accountId, withdrawData) {
    const response = await api.post(
      `/savings/${accountId}/withdraw`,
      withdrawData,
    );
    return response.data;
  },

  async getStatement(accountId, fromDate, toDate) {
    const params = {};
    if (fromDate) params.from_date = fromDate;
    if (toDate) params.to_date = toDate;
    const response = await api.get(`/savings/${accountId}/statement`, {
      params,
    });
    return response.data;
  },

  async closeAccount(accountId, closeData) {
    const response = await api.post(`/savings/${accountId}/close`, closeData);
    return response.data;
  },

  async reverseDeposit(transactionId, reason) {
    const response = await api.post(
      `/savings/transactions/${transactionId}/reverse`,
      { reason },
    );
    return response.data;
  },

  async getDueSavingsCollections(params) {
    const response = await api.get("/savings/due-collections", { params });
    return response.data;
  },

  async recordCollection(accountId, amount, paymentMethod) {
    const response = await api.post(
      `/savings/${accountId}/record-collection`,
      null,
      {
        params: { amount, payment_method: paymentMethod },
      },
    );
    return response.data;
  },

  async getCollectionReport(params) {
    const response = await api.get("/savings/collection-report", { params });
    return response.data;
  },

  async getSavingsAccounts(params = {}) {
    const response = await api.get("/savings", { params });
    return response.data;
  },
};
